"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _zod = require("zod");

var widgetName = 'gainsight-px-script'; // the data config

exports.widgetName = widgetName;
var cssAnchorName = 'widget-gainsight-px-script';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  tag: _zod.z.string()
});

exports.config = config;

var GainsightPxScript = function GainsightPxScript(_ref) {
  var tag = _ref.tag;
  return (0, _preact.h)("script", {
    dangerouslySetInnerHTML: {
      __html: createGainsightPxScript(tag)
    }
  });
}; // default export is the component


var _default = GainsightPxScript;
exports.default = _default;

var createGainsightPxScript = function createGainsightPxScript(tag) {
  return "(function(n,t,a,e,co){var i=\"aptrinsic\";n[i]=n[i]||function(){\n(n[i].q=n[i].q||[]).push(arguments)},n[i].p=e;n[i].c=co;\nvar r=t.createElement(\"script\");r.async=!0,r.src=a+\"?a=\"+e;\nvar c=t.getElementsByTagName(\"script\")[0];c.parentNode.insertBefore(r,c)\n})(window,document,\"https://web-sdk-eu.aptrinsic.com/api/aptrinsic.js\",\"".concat(tag, "\");");
};